import { render, staticRenderFns } from "./DownloadDeposits.vue?vue&type=template&id=bdf7e88c&"
import script from "./DownloadDeposits.vue?vue&type=script&lang=js&"
export * from "./DownloadDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports